(function () {

  const initRecruitGallery = () => {

    // セクション再ロード時に古いカーソル要素をクリア
    document.querySelectorAll('.recruit__drag-cursor').forEach((el) => el.remove());

    const sliders = document.querySelectorAll('.js-recruit-gallery');

    if (!sliders.length) return;

    sliders.forEach((slider) => {

      if (slider.dataset.initialized === 'true') return;

      const track = slider.querySelector('.js-recruit-gallery-track');

      if (!track) return;

      const originalItems = Array.from(track.children);

      if (!originalItems.length) return;

      slider.dataset.initialized = 'true';

      // 無限ループ用に複製
      originalItems.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      let position = 0;
      const autoSpeed = 0.5; // px/frame（自動スクロール速度）
      let rafId = null;
      let isDragging = false;
      let lastDragX = 0;
      let velocity = 0;
      let lastMoveTime = 0;

      const getLoopWidth = () => track.scrollWidth / 2;

      const wrapPosition = () => {
        const loopWidth = getLoopWidth();
        if (loopWidth <= 0) return;
        position = ((position % loopWidth) + loopWidth) % loopWidth;
      };

      const applyTransform = () => {
        track.style.transform = `translate3d(${-position}px, 0, 0)`;
      };

      // 自動スクロール
      const autoScroll = () => {
        position += autoSpeed;
        wrapPosition();
        applyTransform();
        rafId = requestAnimationFrame(autoScroll);
      };

      const startAutoScroll = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(autoScroll);
      };

      const stopAutoScroll = () => {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      };

      // 慣性スクロール（ドラッグ後）
      const momentumScroll = () => {
        if (Math.abs(velocity) < 0.05) {
          velocity = 0;
          rafId = null; // 消費済みIDをクリアしてからautoScrollを起動
          startAutoScroll();
          return;
        }
        position += velocity;
        velocity *= 0.94; // 減衰率
        wrapPosition();
        applyTransform();
        rafId = requestAnimationFrame(momentumScroll);
      };

      // ドラッグ開始
      const onDragStart = (x) => {
        stopAutoScroll();
        isDragging = true;
        lastDragX = x;
        velocity = 0;
        lastMoveTime = performance.now();
        slider.classList.add('is-dragging');
      };

      // ドラッグ中
      const onDragMove = (x) => {
        if (!isDragging) return;
        const now = performance.now();
        const dt = now - lastMoveTime || 16;
        const dx = x - lastDragX;

        // 速度：px/ms → 16ms(1frame)換算、EMAで平滑化
        const instant = (-dx / dt) * 16;
        velocity = instant * 0.4 + velocity * 0.6;

        position -= dx;
        wrapPosition();
        applyTransform();

        lastDragX = x;
        lastMoveTime = now;
      };

      // ドラッグ終了
      const onDragEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        slider.classList.remove('is-dragging');
        rafId = requestAnimationFrame(momentumScroll);
      };

      // ========== カスタムカーソル ==========
      const cursor = document.createElement('div');
      cursor.className = 'recruit__drag-cursor';
      cursor.textContent = 'DRAG';
      document.body.appendChild(cursor);

      const updateCursorPos = (x, y) => {
        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';
      };

      slider.addEventListener('mouseenter', (e) => {
        updateCursorPos(e.clientX, e.clientY);
        cursor.classList.add('is-visible');
      });

      slider.addEventListener('mouseleave', () => {
        if (!isDragging) cursor.classList.remove('is-visible');
      });

      // ========== マウスイベント ==========
      // windowで拾うことでスライダー外に出てもドラッグ継続・カーソル追従
      slider.addEventListener('mousedown', (e) => {
        e.preventDefault();
        onDragStart(e.clientX);
      });

      window.addEventListener('mousemove', (e) => {
        updateCursorPos(e.clientX, e.clientY);
        onDragMove(e.clientX);
      });

      window.addEventListener('mouseup', () => {
        onDragEnd();
        // スライダー外でリリースされた場合はカーソルを非表示
        if (!slider.matches(':hover')) {
          cursor.classList.remove('is-visible');
        }
      });

      // ========== タッチイベント ==========
      slider.addEventListener('touchstart', (e) => {
        onDragStart(e.touches[0].clientX);
      }, { passive: true });

      slider.addEventListener('touchmove', (e) => {
        onDragMove(e.touches[0].clientX);
      }, { passive: true });

      slider.addEventListener('touchend', () => {
        onDragEnd();
      });

      startAutoScroll();

    });

  };

  document.addEventListener('DOMContentLoaded', initRecruitGallery);
  document.addEventListener('shopify:section:load', initRecruitGallery);

})();
